import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * تبِ فعال در **آدرسِ صفحه** نگه داشته می‌شود، نه در stateِ داخلی.
 *
 * چرا: تا امروز تبِ صفحات یا اصلاً در URL نبود، یا با `{ replace: true }`
 * نوشته می‌شد. هر دو حالت یک نتیجه داشت — دکمهٔ «برگشت»ِ مرورگر (و swipeِ
 * برگشت) به **تبِ قبلی** برنمی‌گشت، بلکه کاربر را یک‌باره از «حساب و کتاب»
 * می‌انداخت توی صفحهٔ قبلیِ منو. با `push` هر تب یک ورودیِ تاریخچه می‌گیرد و
 * برگشت/جلو دقیقاً همان مسیری را طی می‌کند که کاربر رفته.
 *
 * @param {string} param   نامِ پارامترِ آدرس (معمولاً "tab")
 * @param {string} fallback مقدارِ پیش‌فرض وقتی آدرس چیزی ندارد
 * @param {string[]} [valid] کلیدهای مجاز؛ مقدارِ ناشناخته به fallback برمی‌گردد
 * @returns {[string, (key: string|null, opts?: {replace?: boolean}) => void]}
 */
export default function useUrlTab(param, fallback, valid) {
  const [sp, setSp] = useSearchParams();
  const raw = sp.get(param);
  // کلیدِ ناشناخته (لینکِ قدیمی، تایپِ دستی) نباید صفحه را خالی نشان دهد
  const value = (valid && valid.length)
    ? (valid.includes(raw) ? raw : fallback)
    : (raw || fallback);

  const set = useCallback((key, opts) => {
    // فرمِ تابعی — وگرنه دو تغییرِ پشتِ‌هم روی یک snapshotِ کهنه سوار می‌شوند
    setSp((prev) => {
      const next = new URLSearchParams(prev);
      if (key === null || key === undefined) next.delete(param);
      else next.set(param, String(key));
      return next;
    }, { replace: !!(opts && opts.replace) });
  }, [setSp, param]);

  return [value, set];
}
